import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

/**
 * TripMaster-only <title>. No-op when title is empty.
 */
export default function TripMasterDocumentTitleHelmet({ title, helmetKey = "tm-document-title" }) {
  const text = typeof title === "string" ? title.trim() : "";
  if (!text) return null;
  return (
    <Helmet key={helmetKey}>
      <title>{text}</title>
    </Helmet>
  );
}

TripMasterDocumentTitleHelmet.propTypes = {
  title: PropTypes.string,
  helmetKey: PropTypes.string,
};
